import { createAuthorizer } from '@/components/authguards/casbin/enforcer';
import { getGlobalRole, getProjectRole, MODULE_SCOPE } from '@/components/authguards/roleInfo';
import { useEffect, useState } from 'react';

export const usePermission = (
  action: string,
  resource: string,
  options?: { projectId?: number },
) => {
  const [allowed, setAllowed] = useState(false);
  const projectId = options?.projectId;
  const roleInfoStr = localStorage.getItem('roleInfo');
  const roleName = roleInfoStr ? JSON.parse(roleInfoStr).name : undefined;

  useEffect(() => {
    const scope = MODULE_SCOPE[resource];
    let role = '';
    if (scope === 'PROJECT' && projectId) {
      if (!projectId) {
        setAllowed(false);
        return;
      }
      role = getProjectRole(projectId);
    } else {
      role = getGlobalRole();
    }

    if (!role) {
      setAllowed(false);
      return;
    }

    const authorizer = createAuthorizer(role);
    authorizer.can(action, resource).then(setAllowed);
  }, [action, resource, projectId]);

  if (roleName === 'SUPER_ADMIN') return true;
  if (roleName === 'ADMIN') return true;
  return allowed;
};
